import React from "react";
import PropTypes from 'prop-types';

const Match = ({ match, equipes }) => {
    const equipe1 = equipes.find(e => e.id === match.equipe1);
    const equipe2 = equipes.find(e => e.id === match.equipe2);

    const isFinale = match.equipe1 === null && match.equipe2 === null;
    const equipe1Perdue = match.score2 === 3;
    const equipe2Perdue = match.score1 === 3;

    return (
        <div className="space-y-2">
            {match.date && (
                <div className="text-sm text-gray-400 font-semibold">
                    {new Date(match.date).toLocaleDateString('fr-FR', { weekday: 'short', month: 'short', day: 'numeric' })}
                    {' • '}
                    {new Date(match.date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                </div>
            )}
            <div className="bg-[#1A1A1A] bg-opacity-70 rounded-lg p-4 backdrop-blur-sm border border-gray-700 hover:border-gray-500 transition-all">
            <div className="flex items-center justify-between">
                <div className={`flex-1 flex items-center gap-2 md:gap-3 ${equipe1Perdue ? 'opacity-50' : ''}`}>
                    {equipe1 ? (
                        <>
                            <img
                                src={`${process.env.PUBLIC_URL}/images/equipes/${equipe1.logo}`}
                                alt={equipe1.name}
                                className="w-8 h-8 md:w-12 md:h-12 rounded-md object-contain flex-shrink-0"
                                onError={(e) => e.target.style.display = 'none'}
                            />
                            <div className="text-left min-w-0">
                                <p className={`hidden md:block font-semibold text-sm md:text-base truncate ${equipe1Perdue ? 'text-gray-500' : 'text-white'}`}>{equipe1.name}</p>
                                <p className="text-xs text-gray-400">{equipe1.teamtag}</p>
                            </div>
                        </>
                    ) : (
                        <div className="text-left text-gray-500 italic text-sm">À déterminer</div>
                    )}
                </div>

                <div className="flex items-center gap-2 md:gap-4 px-2 md:px-6 flex-shrink-0">
                    {!isFinale ? (
                        <>
                            <span className="text-xl md:text-2xl font-bold text-white w-6 md:w-8 text-center">{match.score1}</span>
                            <span className="text-gray-400">-</span>
                            <span className="text-xl md:text-2xl font-bold text-white w-6 md:w-8 text-center">{match.score2}</span>
                        </>
                    ) : (
                        <span className="text-gray-400 text-sm">À venir</span>
                    )}
                </div>

                <div className={`flex-1 flex items-center justify-end gap-2 md:gap-3 ${equipe2Perdue ? 'opacity-50' : ''}`}>
                    {equipe2 ? (
                        <>
                            <div className="text-right min-w-0">
                                <p className={`hidden md:block font-semibold text-sm md:text-base truncate ${equipe2Perdue ? 'text-gray-500' : 'text-white'}`}>{equipe2.name}</p>
                                <p className="text-xs text-gray-400">{equipe2.teamtag}</p>
                            </div>
                            <img
                                src={`${process.env.PUBLIC_URL}/images/equipes/${equipe2.logo}`}
                                alt={equipe2.name}
                                className="w-8 h-8 md:w-12 md:h-12 rounded-md object-contain flex-shrink-0"
                                onError={(e) => e.target.style.display = 'none'}
                            />
                        </>
                    ) : (
                        <div className="text-right text-gray-500 italic">À déterminer</div>
                    )}
                </div>
                </div>
            </div>
        </div>
    );
};

Match.propTypes = {
    match: PropTypes.object.isRequired,
    equipes: PropTypes.array.isRequired,
};

export default Match;






